import { useMemo } from "react";
import DropBox from "../../../../component/DropBox";
import { useDailySettlementContext } from "../../hooks/daily-settlement-context";
import { DailySettlementSection } from "../../hooks/use-daily-settlement-section";
import { UseDailyExcel } from "../../hooks/use-daily-excel";
import {
  DailySettlementDateWrapper,
  DailySettlementTabButtonWrapper,
  DailySettlementTabWrapper,
} from "./style";

const monthList = Array.from({ length: 12 }, (_, i) => ({
  name: `${i + 1}월`,
  value: i + 1,
}));

const yearList = [
  { name: "2026년", value: 2026 },
  { name: "2027년", value: 2027 },
  { name: "2028년", value: 2028 },
];

const DailySettlementTab = () => {
  const {
    year,
    setYear,
    month,
    setMonth,
    day,
    setDay,
    isSection,
    setSection,
    date,
  } = useDailySettlementContext();
  const { createDailyFile } = UseDailyExcel();

  const dayList = useMemo(() => {
    const lastDay = new Date(year, month, 0).getDate();

    return Array.from({ length: lastDay }, (_, i) => ({
      name: `${i + 1}일`,
      value: i + 1,
    }));
  }, [year, month]);

  const tabs = [
    { name: "게임별 상세내역", tab: DailySettlementSection.TOURNAMENT },
    { name: "매출 관리", tab: DailySettlementSection.REVENUE },
    { name: "지출 관리", tab: DailySettlementSection.EXPENSE },
    { name: "래빗 관리", tab: DailySettlementSection.RABBIT },
    { name: "일일 정산", tab: DailySettlementSection.DAILY_SUMMARY },
  ];

  const handleExcel = () => {
    createDailyFile(date);
  };

  return (
    <DailySettlementTabWrapper>
      <DailySettlementTabButtonWrapper>
        {tabs.map((t, i) => (
          <div
            key={i}
            className={`button ${isSection(t.tab) ? "selected" : ""}`}
            onClick={() => setSection(t.tab)}
          >
            {t.name}
          </div>
        ))}
      </DailySettlementTabButtonWrapper>
      <DailySettlementDateWrapper>
        <DropBox
          value={year}
          setValue={setYear}
          list={yearList}
          isBig={true}
          width="69px"
        />
        <DropBox
          value={month}
          setValue={setMonth}
          list={monthList}
          isBig={true}
          width="40px"
        />
        <DropBox
          value={day}
          setValue={setDay}
          list={dayList}
          isBig={true}
          width="45px"
        />
        <div className="save" onClick={handleExcel}>
          <img src="/image-web/solution/save.svg" alt="save" />
        </div>
      </DailySettlementDateWrapper>
    </DailySettlementTabWrapper>
  );
};

export default DailySettlementTab;
